/* @flow */

import buscarContatos from './buscar-contatos';

import { type Usuario } from './types';

const adicionarContatos = async (usuarios: Usuario[]) => {
    const contatos = await Promise.all(usuarios.map(usuario => buscarContatos(usuario)));

    usuarios.forEach((usuario, index) => {
        usuario.contatos = contatos[index].data;
    });

    return usuarios;
};

export default adicionarContatos;
